const commonParentStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  height: '100%',
};

const iconCommonStyles = {
  fontSize: '36px',
  lineHeight: '36px',
  color: '#0078d4',
};

export const getPlaceholderStyle = () => ({
  '@global': {
    '@keyframes spinner': {
      to: {
        transform: 'rotate(360deg)',
      },
    },
    '@keyframes downloading': {
      from: {
        transform: 'translateY(-18px)',
      },
      to: {
        transform: 'translateY(42px)',
      },
    },
  },
  encoding: {
    ...commonParentStyles,
    '& .placeholder-icon': {
      ...iconCommonStyles,
      animation: 'spinner 1.2s linear infinite',
    },
    '.add-video-content-container &': {
      marginTop: 14,
    },
  },
  unverified: {
    ...commonParentStyles,
    '& .download-icon-container': {
      overflow: 'hidden',
      borderBottom: '2px solid #0078d4',
    },
    '& .placeholder-icon': {
      ...iconCommonStyles,
      animation: 'downloading 1.2s ease infinite',
    },
  },
  failed: {
    ...commonParentStyles,
    '& .placeholder-icon': {
      ...iconCommonStyles,
      color: '#d83b01',
    },
  },
});
